/*
 * OktaVerifyStepOne Messages
 *
 * This contains all the text for the OktaVerifyStepOne component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.OktaVerifyStepOne";

export default defineMessages(scope, {
  header: "This is the OktaVerifyStepOne component!",
  listItem1:
    "On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).",
  listItem2: "Open the app and follow the instructions to add your account.",
  listItem3: "When prompted, tap Scan a QR code, then scan the QR code below:",
  listItem4: "Click next after completing the set-up process in the app.",
  nextButtonLabel: "Next",
  cantScanLabel: "Can’t scan?",
  cancelButtonLabel: "Cancel",
  loadingMessage: "loading...",
});
